module.exports = __webpack_public_path__ + "img/threeD-cover-2.140f6b5d.png";